import { Col } from "antd-v4";

import imgLoader from "../../../assets/images/loader.gif";

export default function Loader() {
  return (
    <Col span={24} className="hp-m-48 hp-text-center">
      <img src={imgLoader} alt="Loader" width={48} height={48} />
    </Col>
  );
}
